(() => {
  const siblingProducts = document.querySelectorAll('[data-sibling-color]');

  siblingProducts.forEach((sibling) => {
    // When hovering a data sibling color replace the active color name.
    
    const activeSiblings = document.querySelectorAll('[data-active-sibling-color]');
    const activeSiblingColor = activeSiblings[0].dataset.activeSiblingColor;
    sibling.addEventListener('mouseenter', () => {
      activeSiblings.forEach((activeSibling) => {
        activeSibling.textContent = sibling.dataset.siblingColor;
      });
    });

    sibling.addEventListener('mouseleave', () => {
      activeSiblings.forEach((activeSibling) => {
        activeSibling.textContent = activeSiblingColor;
      });
    });

    sibling.addEventListener('click', () => {
      console.log(sibling.dataset.siblingColor);
      const activeSiblings = document.querySelectorAll('[data-sibling-color]');
      activeSiblings.forEach((activeSibling) => {
        activeSibling.classList.remove('is-active');
      });
      sibling.classList.add('is-active');
    });
  });
})();
